import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
    Button,
    Card,
    CardBody,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row
} from "reactstrap";

import moment from "moment";
import { Colxx, Separator } from "../../../../components/common/CustomBootstrap";
import { firestore } from "../../../../helpers/Firebase";
import { CalculatePoints, createNotification, getAmountColor, getAmountSign, getDescription, getTitle } from "../../../../helpers/Utils";

const WasherWallet = ({ selectedOutlet, activeItem }) => {
    console.log(selectedOutlet)
    const [customerWallet, setCustomerWallet] = useState([])
    const [showModal, setShowModal] = useState(false)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)

    const filteredWallet = useMemo(() => {
        if (!customerWallet?.length) return []
        if (!startDate && !endDate) return customerWallet
        const rangeStart = startDate ? moment(startDate).startOf('day').valueOf() : null
        const rangeEnd = endDate ? moment(endDate).endOf('day').valueOf() : null
        return customerWallet.filter(item => {
            const created = Number(item?.created)
            if (!created) return false
            if (rangeStart && created < rangeStart) return false
            if (rangeEnd && created > rangeEnd) return false
            return true
        })
    }, [customerWallet, startDate, endDate])

    const handleDateRangeChange = (dates) => {
        const [start, end] = dates || []
        setStartDate(start || null)
        setEndDate(end || null)
    }
    useEffect(() => {
        if (selectedOutlet) {
            const unsubscribeWallet = firestore().collection('washers').doc(selectedOutlet.key).collection('walletLog').onSnapshot((snap) => {
                let data = snap.docs.map(rec => {
                    return { ...rec.data(), id: rec.id, key: rec.id }
                })
                data = data?.sort((a, b) => b.created - a.created)?.filter(t => !t?.voided)
                setCustomerWallet(data)
            })

            // Cleanup function to unsubscribe listener
            return () => {
                unsubscribeWallet()
            }
        }
    }, [selectedOutlet])
    const settleTips = async () => {
        try {
            let data = customerWallet?.filter(t => !t?.voided && !t?.transferred);
            const totalWasherTip = CalculatePoints(data).totalWasherTip;

            if (totalWasherTip > 0) {
                const batch = firestore().batch();
                data.forEach(doc => {
                    const docRef = firestore().collection('washers').doc(selectedOutlet.id).collection('walletLog').doc(doc.id);
                    batch.update(docRef, { transfered: moment().valueOf() });
                });
                await batch.commit();
                createNotification('success', 'Worker Tips settled successfully');
                setShowModal(false)
            }
        } catch (error) {
            console.error("Error settling tips: ", error);
        }
    };

    return (

        <Card className="rounded">
            <CardBody>
                <Row>
                    <Colxx xxs="12" >
                        <div className="mb-2" style={{ display: 'flex', alignItems: 'center', columnGap: '1.5rem' }}>
                            <h1 style={{ whiteSpace: 'nowrap', margin: 0 }}>
                                Worker Tips
                            </h1>
                            <div style={{ width: '240px', flexShrink: 0, marginLeft: 'auto' }}>
                                <DatePicker
                                    onChange={handleDateRangeChange}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                    dateFormat={'dd/MM/yyyy'}
                                    placeholderText="Filter by date range"
                                    isClearable
                                />
                            </div>
                            <Button
                                disabled={CalculatePoints(customerWallet).totalWasherTip <= 0}
                                color="success"
                                className="btn-shadow"
                                size="sm"
                                style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
                                onClick={() => setShowModal(true)}>Settle Total Worker Tips: AED {CalculatePoints(customerWallet).totalWasherTip.toFixed(2)}
                            </Button>
                        </div>
                        <Separator className="mb-3" />
                        {(startDate || endDate) && (
                            <div className="mb-3" style={{ fontSize: '0.85rem', color: '#6b7280' }}>
                                Showing {filteredWallet.length} of {customerWallet.length} records
                            </div>
                        )}
                    </Colxx>
                </Row>



                <div className="p-4" style={{ height: '500px', overflowY: 'auto' }}>
                    {filteredWallet?.length ? (
                        <>
                            <Row className="d-flex align-items-center pb-2" style={{ borderBottom: '1px solid #e5e5e5' }}>
                                <Colxx xxs="3" style={{ fontWeight: '700' }}>Type</Colxx>
                                <Colxx xxs="3" style={{ fontWeight: '700' }}>Description</Colxx>
                                <Colxx xxs="3" style={{ fontWeight: '700' }}>Created</Colxx>
                                <Colxx xxs="3" style={{ fontWeight: '700' }}>Amount</Colxx>
                            </Row>
                            {filteredWallet.map((item) => {
                                return (
                                    <React.Fragment key={item.key || item.id}>
                                        <Row className="d-flex align-items-center mt-3">
                                            <Colxx xxs="3">
                                                <span>{getTitle(item)}</span>
                                            </Colxx>
                                            <Colxx xxs="3">
                                                <span>{getDescription(item) || '--'}</span>
                                            </Colxx>
                                            <Colxx xxs="3">
                                                <span>{moment(item?.created).format('DD/MM/YYYY hh:mm A')}</span>
                                            </Colxx>
                                            <Colxx xxs="3">
                                                <span style={{ fontWeight: 'bold', color: getAmountColor(item) }}>{`${getAmountSign(item)} AED ${(Number(item.amount) * 0.9705).toFixed(2)}`}</span>
                                            </Colxx>
                                        </Row>
                                        <Separator className="mt-3" />
                                    </React.Fragment>
                                )
                            })}
                        </>
                    ) : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '350px', fontSize: '18px' }}>{customerWallet?.length ? 'No records in selected date range' : 'No data found'}</div>}
                </div>
                <Modal isOpen={showModal} toggle={() => { }} size="md">
                    <ModalHeader>Settle Worker Tips</ModalHeader>
                    <ModalBody>
                        Are you sure you want to settle the worker tips?
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={() => {
                            setShowModal(false);
                        }}>Dismiss</Button>
                        <Button color="primary" onClick={() => {
                            settleTips();
                        }}>Settle Amount</Button>
                    </ModalFooter>
                </Modal>
            </CardBody>
        </Card>
    );
};

export default WasherWallet;